import {
  closestCorners,
  DndContext,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  horizontalListSortingStrategy,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useFieldArray, useForm, useFormContext } from "react-hook-form";
import {
  Button,
  Card,
  Col,
  FloatingLabel,
  Form,
  Row,
  Spinner,
  Table,
  Modal,
} from "react-bootstrap";

import Select from "react-select";
import CustomOption from "utils/CustomOption";
import ActionButton from "components/common/ActionButton";
import { useFetchCategories } from "../../../../hooks/useFetchCategories";
import { useEffect, useState } from "react";
import { useFetchCategoriesGroup } from "hooks/useFetchCategoriesGroup";

const SortableCheckbox = ({ id, label, register, errors }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: isDragging ? "grabbing" : "grab",
    userSelect: "none",
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className="d-flex align-items-center"
    >
      <Form.Check
        type="checkbox"
        // id={id}
        isInvalid={!!errors[id]}
        {...register(id)}
        label={
          <span
            style={{
              cursor: isDragging ? "grabbing" : "grab",
              userSelect: "none",
            }}
          >
            {label}
          </span>
        }
      />
    </div>
  );
};

const LogoAndStandardEcomOptionsModal = ({
  show,
  block,
  onClose,
  onChange,
}) => {
  const {
    register,
    setValue,
    clearErrors,
    handleSubmit,
    control,
    trigger,
    watch,
    setError,
    formState: { errors, isDirty },
  } = useForm({
    defaultValues: block.settings,
  });

  const submit = (data) => {
    onChange(data); // ✅ one controlled update
    onClose();
  };

  const [options, setOptions] = useState([
    { id: "search", label: "Search" },
    { id: "language", label: "Language" },
    { id: "help", label: "Help" },
    { id: "wishlist", label: "Wishlist" },
    { id: "cart", label: "Cart" },
    { id: "signin", label: "SignIn" },
    { id: "signup", label: "SignUp" },
  ]);

  const sensors = useSensors(
    useSensor(MouseSensor, { activationConstraint: { distance: 5 } }),
    useSensor(TouchSensor, {
      activationConstraint: { delay: 150, tolerance: 5 },
    }),
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (!over || active.id === over.id) return;

    setOptions((items) => {
      const oldIndex = items.findIndex((i) => i.id === active.id);
      const newIndex = items.findIndex((i) => i.id === over.id);

      const updated = [...items];
      const [moved] = updated.splice(oldIndex, 1);
      updated.splice(newIndex, 0, moved);

      return updated;
    });
  };

  return (
    <Modal show={show} onHide={onClose} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Logo + Standard ECommerce Options</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row className="gx-2">
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="file"
                  placeholder="Logo"
                  title="Logo"
                  className="py-2"
                  isInvalid={!!errors.logo}
                  {...register("logo")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.logo?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
          </Row>

          <h5 className="fs-10 mb-0 text-nowrap py-2">Standard Options</h5>

          <DndContext
            sensors={sensors}
            collisionDetection={closestCorners}
            onDragEnd={handleDragEnd}
          >
            <SortableContext
              items={options.map((o) => o.id)}
              strategy={horizontalListSortingStrategy}
            >
              <div className="d-flex flex-row flex-wrap gap-4 mt-2">
                {options.map((option) => (
                  <SortableCheckbox
                    key={option.id}
                    id={option.id}
                    label={option.label}
                    register={register}
                    errors={errors}
                  />
                ))}
              </div>
            </SortableContext>
          </DndContext>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSubmit(submit)}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LogoAndStandardEcomOptionsModal;
